import { DownloadIcon } from "../../assets/icons/icon-cloud-download";

export const DownloadButtonContents = () => {
  const template = `
    ${DownloadIcon} <span class="btn--primary__text">Fill</span>
  `;

  return template;
};
